import captchatypeConfig from './captchatype/captchatypeConfig';
import profileConfig from './profile/profileConfig';
import userRouteConfig from './user/userRouteConfig';
import captchatogenerateConfig from './captchatogenerate/captchatogenerateConfig';
import captchagenstatConfig from './captchagenstat/captchagenstatConfig';
import statusConfig from './status/statusConfig';
import suspicionConfig from './suspicion/suspicionConfig';

const AdminConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [...userRouteConfig, ...profileConfig, ...captchatypeConfig, ...captchatogenerateConfig, ...captchagenstatConfig, ...statusConfig, ...suspicionConfig]
};

export default AdminConfig;
